import { useLocation } from 'react-router';
import { ga } from '@/lib/analytics';

/** GA `page` parameter for the route the component is rendered in. */
export const useGAPageName = () =>
  ga.pageName(useLocation().pathname);

export default useGAPageName;
